import { useNavigate } from "react-router-dom";
import { AdminReportsResponse, ReportLevel } from "../adminReportsApiSlice";
import { PromptTable } from "./PromptTable";
import { UsageAndPerformanceByPromptRow } from "./adminPromptReportApiSlice";

export function UsageAndPerformanceByPromptTable(props: {
	className: string;
	level: ReportLevel;
	data: AdminReportsResponse<UsageAndPerformanceByPromptRow>;
	hideRows: boolean;
}) {
	const navigate = useNavigate();

	function handleNameClick(row: UsageAndPerformanceByPromptRow) {
		navigate(`/adminReports/promptUsageAndPerformanceByLevel?promptId=${row.promptId}`);
	}

	return (
		<PromptTable
			className={props.className}
			level={props.level}
			data={props.data}
			hideRows={props.hideRows}
			dataKey="promptId"
			nameField="promptName"
			nameHeader="Prompt"
			onNameClick={handleNameClick}
		/>
	);
}
